<template>
  <div class="post">
    <a-tabs class="tabs" @change="handelStatusChange" v-model="tab">
      <template v-for="tab in tabs">
        <a-tab-pane :key="tab.key" :tab="tab.text">
          <span slot="tab">{{ tab.text }}</span>
        </a-tab-pane>
      </template>
    </a-tabs>
    <a-row :gutter="30" style="padding-top: 30px">
      <a-col span="24" style="margin-bottom: 25px">
        <a-radio-group
          v-model="params.pm_type"
          buttonStyle="solid"
          style="margin-right: 12px"
          @change="
            () => {
              btnType = 'default';
              getData();
            }
          "
        >
          <a-radio-button value="dev">我开发的</a-radio-button>
          <a-radio-button value="active">我激活的</a-radio-button>
          <a-radio-button value="public_pool">公池</a-radio-button>
        </a-radio-group>
        <a-button class="invalid-btn" :type="btnType" @click="getInvalidData"
          >无效猎头</a-button
        >
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">注册时间</a-col>
          <a-col span="18">
            <a-range-picker
              style="display: block"
              format="YYYY-MM-DD"
              v-model="params.created_time"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">所在城市</a-col>
          <a-col span="18">
            <a-cascader
              changeOnSelect
              :options="options"
              v-model="params.city"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              placeholder="请选择城市"
              style="display: block"
              @click="getOptions"
            ></a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">擅长行业</a-col>
          <a-col span="18">
            <a-cascader
              changeOnSelect
              :options="industry_id"
              v-model="params.industry"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              placeholder="请选择行业"
              style="display: block"
              @click="getIndustry_id"
            ></a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-input-group compact>
            <a-select
              defaultValue="name"
              style="width: 35%"
              @change="changeCondition"
            >
              <a-select-option value="name">猎头姓名</a-select-option>
              <a-select-option value="tel">手机号</a-select-option>
              <a-select-option value="email">邮箱</a-select-option>
            </a-select>
            <a-input
              style="width: 65%"
              placeholder="请输入信息"
              v-model="params.values"
            ></a-input>
          </a-input-group>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">开发者</a-col>
          <a-col span="18">
            <a-input-group compact>
              <a-auto-complete
                placeholder="请输入开发者查询"
                style="display: block; width: 100%"
                v-model="params.pm_dev_uid"
                @change="changePmDev"
                :dataSource="dataPm_dev_uid"
              ></a-auto-complete>
            </a-input-group>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">激活者</a-col>
          <a-col span="18">
            <a-input-group compact>
              <a-auto-complete
                placeholder="请输入激活者查询"
                style="display: block; width: 100%"
                v-model="params.pm_uid"
                @change="changePm"
                :dataSource="dataPm_uid"
              ></a-auto-complete>
            </a-input-group>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">擅长职能</a-col>
          <a-col span="18">
            <a-cascader
              changeOnSelect
              :options="function_id"
              v-model="params.category_id"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              placeholder="请选择职能"
              style="display: block"
              @click="getFunction_id"
            ></a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <!--<a-col span="12" style="margin-bottom:25px;">-->
      <!--<a-row type="flex" align="top">-->
      <!--<a-col span="6" style="border: none;width: 80px">签约状态</a-col>-->
      <!--<a-col span="18">-->
      <!--<a-radio-group :options="signingOptions" @change="onChangeSigning"  v-model="params.signing"/>-->
      <!--</a-col>-->
      <!--</a-row>-->
      <!--</a-col>-->
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">备注内容</a-col>
          <a-col span="18">
            <a-input
              v-model="params.hunter_remark_body"
              placeholder="请输入关键词查询"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" style="border: none; width: 80px">用户角色</a-col>
          <a-col span="18">
            <a-radio-group
              :options="role"
              @change="onChangeSigning"
              v-model="params.role_type"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col span="12" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="9">
            <a-checkbox @change="changeCheckBox" :checked="checked"
            >查看标黑的猎头</a-checkbox
            >
          </a-col>
          <a-col span="9">
            <a-checkbox @change="changeCheckBox" :checked="checked"
            >手标优质猎头</a-checkbox
            >
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button
          type="primary"
          style="margin-right: 12px; padding: 0 30px"
          @click="getData()"
          >筛选</a-button
        >
        <a-button style="margin-right: 12px" @click="resetParams"
          >清空筛选条件</a-button
        >
        <span>共找到 {{ pagination.total }} 条信息</span>
      </a-col>
      <a-col>
        <!--<a-button-->
        <!--type="primary"-->
        <!--@click="exportData"-->
        <!--v-if="isGranted('hunter_manager.hunter_list.btn_export_hunter_data')"-->
        <!--&gt;导出数据</a-button>-->
        <a-button type="primary" @click="signData">标记开发人</a-button>&nbsp;
        <a-button type="primary" @click="getPromotionLinks"
          >获取推广链接</a-button
        >
      </a-col>
    </a-row>

    <a-table
      :columns="columns"
      :dataSource="list"
      class="hunter-table"
      :pagination="pagination"
      :loading="loading"
      rowKey="id"
      @change="getData"
      :customRow="clickCustomRow"
    >
      <span slot="name" slot-scope="text">{{ text }}</span>
      <span slot="ie_user" slot-scope="text, record">
        {{ record.ie_user.name }}
      </span>
            <span slot="enterprise_user" slot-scope="text,record">
        {{record.enterprise_user.name}}
      </span>
      <span slot="status" slot-scope="text, record">
        {{
          record.is_sub_user
            ? "猎企成员"
            : record.hunter.is_sign == "0"
            ? "未签约"
            : record.hunter.is_enterprise == "NO"
            ? "已签约猎头"
            : "已签约猎企"
        }}
      </span>
      <span slot="role_type" slot-scope="role_type">
        {{ role_type == "1" ? "猎头" : role_type == "2" ? "HR" : "创业者" }}
      </span>
      <!--refuse-->
      <template slot="action" slot-scope="record" class="action" @click.stop>
        <a-row
          v-if="record.invalid === '1'"
          type="flex"
          justify="center"
          :gutter="10"
        >
          <a-col>
            <a @click.stop="changeValidHunter(record.id)">转为有效猎头</a>
          </a-col>
        </a-row>
        <a-row v-else type="flex" justify="center" :gutter="10">
          <!-- <a-col>
            <a @click.stop="$refs.followUpModal.show(record)">跟进</a>
          </a-col> -->
          <a-col>
            <template
              v-if="
                isGranted('hunter_manager.hunter_list.btn_remark') &&
                (record.pm_uid == 0 || record.pm_uid == user.uid) &&
                params.pm_type === 'public_pool'
              "
            >
              <!-- <a-icon
                type="edit"
                style="cursor:pointer"
                title="跟进"
                @click.stop="$refs.followUpModal.show(record)"
              ></a-icon> -->
              <a @click.stop="$refs.followUpModal.show(record)">跟进</a>
              <a-divider type="vertical"></a-divider>
            </template>
            <a
              @click.stop="$refs.remarkDetailModal.show(record.id)"
              title="查看跟进"
              >查看跟进</a
            >
          </a-col>
          <a-col
            v-if="
              record.is_need_audit &&
              isGranted('hunter_manager.hunter_list.btn_audit')
            "
          >
            <a @click.stop="goContracts(record)">审核</a>
          </a-col>
          <a-col
            v-if="
              record.is_contract &&
              isGranted('hunter_manager.hunter_list.btn_contract_manage')
            "
          >
            <a @click.stop="goContracts(record)">合同管理</a>
          </a-col>
          <a-col
            v-if="record.pm_dev_uid == user.uid && params.pm_type === 'dev'"
          >
            <a @click.stop="$refs.transformPmModal.show(record)">转移开发者</a>
          </a-col>
        </a-row>
      </template>
    </a-table>
    <a-modal v-model="hunterModel" title="猎头信息" width="637px">
      <template slot="footer">
        <a-button key="back" @click="closeModel">取消</a-button>
      </template>
      <a-spin :spinning="!hunterInfo.report_data" style="width: 100%">
        <div v-if="hunterInfo.report_data">
          <h3>基本信息</h3>
          <a-row>
            <a-col span="12">
              <p>中文名：{{ hunterInfo.name }}</p>
            </a-col>
            <a-col span="12">
              <p>邮箱：{{ hunterInfo.email }}</p>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <p>英文名：{{ hunterInfo.name_en }}</p>
            </a-col>
            <a-col span="12">
              <p>电话：{{ hunterInfo.tel }}</p>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <p>
                签约状态：{{
                  hunterInfo.is_sub_user
                    ? "猎企成员"
                    : hunterInfo.hunter.is_sign == "0"
                    ? "未签约"
                    : hunterInfo.hunter.is_enterprise == "NO"
                    ? "已签约猎头"
                    : "已签约猎企"
                }}
              </p>
            </a-col>
            <a-col span="12">
              <p>
                合同期限：{{
                  hunterInfo.contract.start_time | format("YYYY-MM-DD")
                }}
                至 {{ hunterInfo.contract.end_time | format("YYYY-MM-DD") }}
              </p>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <p>所在地区：{{ hunterInfo.city_name }}</p>
            </a-col>
            <a-col span="12">
              <p>最近登录时间：{{ hunterInfo.login_at }}</p>
            </a-col>
          </a-row>
          <p>所属猎企：{{ hunterInfo.company }}</p>
          <div style="align-items: flex-start">
            擅长行业：
            <p style="flex: 1">
              <span
                v-for="(item, i) in hunterInfo.hunter.specialized_industry"
                :key="i"
              >
                {{ item.first_category_name
                }}{{ item.second_category_name ? "/" : ""
                }}{{ item.second_category_name
                }}{{
                  i === hunterInfo.hunter.specialized_industry.length - 1
                    ? ""
                    : "、"
                }}
              </span>
            </p>
          </div>
          <div style="align-items: flex-start" class="model-list">
            擅长职能：
            <p style="flex: 1">
              <span
                v-for="(item, i) in hunterInfo.hunter.specialized_function"
                :key="i"
              >
                {{ item.first_category_name
                }}{{ item.second_category_name ? "/" : ""
                }}{{ item.second_category_name
                }}{{ item.third_category_name ? "/" : ""
                }}{{ item.third_category_name
                }}{{
                  i === hunterInfo.hunter.specialized_function.length - 1
                    ? ""
                    : "、"
                }}
              </span>
            </p>
          </div>
          <a-divider></a-divider>
          <div class="listtitle">做单信息</div>
          <a-row class="row-content" type="flex" justify="start" align="middle">
            <a-col class="col">
              <span
                >最近一次做单：<span
                  class="blue"
                  style="cursor: pointer"
                  @click="
                    $router.push(
                      '/order/detail/' + hunterInfo.report_data.latest_post.id
                    )
                  "
                  v-if="hunterInfo.report_data.latest_post.id"
                  >{{ hunterInfo.report_data.latest_post.order_no }}</span
                ></span
              >
            </a-col>
            <a-col class="col">
              <span
                >最近一次做单时间：{{
                  hunterInfo.report_data.latest_post.created_at || "-"
                }}</span
              >
            </a-col>
            <a-col class="col">
              <span
                >接单数：<span class="blue">{{
                  hunterInfo.report_data.post_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >一面数：<span class="blue">{{
                  hunterInfo.report_data.interview_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >offer数：<span class="blue">{{
                  hunterInfo.report_data.offer_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >入职数：<span class="blue">{{
                  hunterInfo.report_data.entry_count
                }}</span></span
              >
            </a-col>
            <a-col class="col">
              <span
                >过保数：<span class="blue">{{
                  hunterInfo.report_data.complete_count
                }}</span></span
              >
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </a-modal>
    <remark-modal ref="remarkModal" @ok="doRemark"></remark-modal>
    <remark-detail-modal ref="remarkDetailModal"></remark-detail-modal>
    <a-modal
      title="添加开发人"
      @ok="saveSign"
      v-model="signModel"
      :destroyOnClose="true"
    >
      <a-form :form="form">
        <a-form-item label="手机号" style="margin-bottom: 0">
          <a-input
            placeholder="请输入添加对象的手机号"
            :rows="6"
            v-decorator="[
              'tel',
              {
                rules: [{ required: true, message: '请输入添加对象的手机号' }],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="备注" style="margin-bottom: 0">
          <a-textarea
            :rows="6"
            v-decorator="[
              'body',
              { rules: [{ required: true, message: '请填写备注' }] },
            ]"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="专属推广链接"
      v-model="promotionLinks"
      :destroyOnClose="true"
    >
      <template slot="footer">
        <a-button key="back" @click="cancelCopy">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          v-clipboard:copy="
            copyUrldata + '/app/invite/login?pm_uid=' + this.$store.state.user.uid
          "
          v-clipboard:success="copyUrl"
          v-clipboard:error="onError"
          >复制地址</a-button
        >
      </template>
      地址：{{ copyUrldata + "/app/invite/login?pm_uid=" + this.$store.state.user.uid }}
    </a-modal>
    <transform-pm-modal ref="transformPmModal"></transform-pm-modal>
    <follow-up-modal ref="followUpModal" :callback="getData"></follow-up-modal>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapMutations } from "vuex";
import Api from "@/api";
import Pagination from "@/components/Pagination";
import baseComponentVue from "@/components/base-component.vue";
import RemarkModal from "./mark-modal";
import RemarkDetailModal from "./mark-detail-modal";
import TransformPmModal from "./transform-pm-modal";
import FollowUpModal from "./follow-up-modal";

// const columns =
var tabParams = {};
export default {
  name: "post",
  extends: baseComponentVue,
  data() {
    return {
      form: this.$form.createForm(this),
      checked: false,
      copyUrldata:process.env.VUE_APP_BASEURL === "https://ie-api-test.lucasgchr.com"
                ? "https://apph5-test.lucasgchr.com"
                : "https://apph5.lucasgchr.com",
      options: [],
      function_id: [],
      industry_id: [],
      list: [],
      columns:[
  {
    title: "用户ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "手机号",
    dataIndex: "tel",
    key: "tel",
  },
  {
    title: "所在城市",
    dataIndex: "city_name",
    key: "city_name",
  },
  {
    title: "开发者",
    dataIndex: "pm_dev_name",
    key: "pm_dev_name",
  },
  {
    title: "激活者",
    dataIndex: "pm_name",
    key: "pm_name",
  },
  {
    title: "用户角色",
    dataIndex: "role_type",
    key: "role_type",
    scopedSlots: { customRender: "role_type" },
  },
  {
    title: "签约状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "猎企负责人",
    dataIndex: "enterprise_user",
    key: 'enterprise_user',
    scopedSlots: { customRender: "enterprise_user" },
  },
  {
    title: "最近状态变更时间",
    dataIndex: "updated_at",
    key: "contract_updated_at",
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
],
      tab: "all",
      tabs: Object.freeze([
        {
          text: "全部猎头",
          key: "all",
        },
        {
          text: "已签约猎头",
          key: "is_sign",
        },
        {
          text: "已签约猎企",
          key: "is_enterprise",
        },
        {
          text: "待审核猎头/猎企",
          key: "audit_status",
        },
        {
          text: "未签约",
          key: "not_sign",
        },
      ]),
      searchValue: "name",
      params: {
        statuses: "",
        pm_type: "dev",
        created_time: null,
        category_id: [],
        industry: [],
        id: "",
        state: "",
        city: [],
        role_type: "",
        values: "",
        pm_uid: "",
        pm_dev_uid: "",
      },
      btnType: "default",
      listData: [],
      total: 0,
      signingOptions: [
        { label: "待签约", value: "Apple" },
        { label: "已签约猎头", value: "Pear" },
        { label: "已签约猎企", value: "Orange" },
      ],
      role: [
        { label: "猎头", value: "1" },
        { label: "HR", value: "2" },
        { label: "创业者", value: "3" },
      ],
      loading: false,
      remark: [],
      hunterId: "",
      pagination: {
        current: 1,
        size: "small",
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ["10", "20", "50"], // 每页数量选项
        showTotal: (total) => `共 ${total} 条`, // 显示总数
        showQuickJumper: true,
        total: 0, //总条数
      },
      hunterModel: false,
      signModel: false,
      promotionLinks: false,
      hunterInfo: [],
      dataPm_uid: [],
      dataPm_dev_uid: [],
    };
  },
  created() {
    tabParams = {};
    this.getData();
  },
  mounted() {},
  computed: {
    ...mapState(["user"]),
    ...mapMutations(["toggleJobView"]),
  },
  components: {
    Pagination,
    RemarkModal,
    RemarkDetailModal,
    TransformPmModal,
    FollowUpModal,
  },
  methods: {
    changeCheckBox(e) {
      console.log(e);
      this.checked = !this.checked;
      if (this.checked) {
        this.params.mark_black = 1;
      } else {
        this.params.mark_black && delete this.params.mark_black;
      }
    },
    handelStatusChange(key) {
      if (key === "all") {
        tabParams = {};
      }
      if (key === "is_sign") {
        tabParams = { is_sign: 1 };
      }
      if (key === "is_enterprise") {
        tabParams = { is_sign: 1, is_enterprise: 1 };
      }
      if (key === "audit_status") {
        tabParams = { audit_status: "PENDING" };
      }
      if (key === "not_sign") {
        tabParams = { is_sign: 0 };
      }
      this.getData();
    },
    async getOptions() {
      let response;
      try {
        response = await Api.common.getCityTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.options = response.tree;
    },
    async getFunction_id() {
      let response;
      try {
        response = await Api.common.getPostTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.function_id = response.tree;
    },
    async getIndustry_id() {
      let response;
      try {
        response = await Api.common.getIndustryTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.industry_id = response.tree;
    },
    resetParams() {
      this.btnType = "default";
      this.checked = false;
      let params = {
        pm_type: "dev",
        statuses: "",
        created_time: null,
        category_id: [],
        industry: [],
        id: "",
        state: "",
        city: [],
        role_type: "",
        values: "",
        pm_uid: "",
      };
      this.params = { statuses: this.params.statuses, ...params };
    },
    changeCondition(value) {
      this.searchValue = value;
    },
    getInvalidData() {
      this.btnType = "primary";
      this.params.pm_type = "";
      this.getData(null, 1);
    },
    async getData(pagination, invalid) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      if (invalid) {
        this.params.invalid = invalid;
      } else {
        delete this.params.invalid;
      }
      let params = {
        ...this.params,
        ...tabParams,
        created_start:
          this.params.created_time &&
          this.params.created_time[0].format("YYYY-MM-DD"),
        created_end:
          this.params.created_time &&
          this.params.created_time[1].format("YYYY-MM-DD"),
        province_id: this.params.city && this.params.city[0],
        city_id: this.params.city && this.params.city[1],
        dist_id: this.params.city && this.params.city[0],
        specialized_industry: JSON.stringify([
          {
            first_category_id: this.params.industry && this.params.industry[0],
            second_category_id: this.params.industry && this.params.industry[1],
          },
        ]),
        specialized_function: JSON.stringify([
          {
            first_category_id: this.params.category_id[0],
            second_category_id: this.params.category_id[1],
            third_category_id: this.params.category_id[2],
            forth_category_id: this.params.category_id[3],
          },
        ]),
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      };
      if (this.searchValue == "name") {
        params.name = this.params.values;
      } else if (this.searchValue == "tel") {
        params.mobile = this.params.values;
      } else if (this.searchValue == "email") {
        params.email = this.params.values;
      }
      if (params.role_type == "") {
        delete params.role_type;
      }
      delete params.created_time;
      try {
        var response = await Api.hunter.getHunterList(params);
        console.log(response, "response");
      } catch (err) {
        this.loading = false;
      }
      this.loading = false;
      this.pagination.total = response.total ? +response.total : 0;
      this.list = response.list;
      // this.columns[8] = {
      //   title: "猎企负责人",
      //   dataIndex: "enterprise_user",
      //   key: `${enterprise_user.name}`,
      // };
    },
    exportData() {},
    goContracts(record) {
      this.$router.push({
        path: "/hunter-contracts",
        query: {
          id: record.id,
        },
      });
      //   if (record.pm_uid > 0) {
      //     this.$router.push({
      //       path: "/hunter-contracts",
      //       query: {
      //         id: record.id
      //       }
      //     });
      //   } else {
      //     this.$message.info("该用户无开发者，请先编辑“备注”标记开发者!");
      //   }
    },
    onChangeSigning(e) {
      // this.params.role_type=e.target.value
    },
    changePm(value) {
      if (value.length >= 2) {
        Api.post.getSuggest({ name: value }).then((res) => {
          const data = [];
          res.forEach((item) => {
            data.push({
              text: item.name,
              value: item.uid,
            });
          });
          this.dataPm_uid = data;
        });
      }
      if (value.length < 2) {
        this.productList = [];
        this.hrList = [];
      }
    },
    changePmDev(value) {
      if (value.length >= 2) {
        Api.post.getSuggest({ name: value }).then((res) => {
          const data = [];
          res.forEach((item) => {
            data.push({
              text: item.name,
              value: item.uid,
            });
          });
          this.dataPm_dev_uid = data;
        });
      }
      if (value.length < 2) {
        this.productList = [];
        this.hrList = [];
      }
    },
    async doRemark(values, id) {
      try {
        await Api.hunter.addRemark({ user_id: id, body: values });
        this.$refs.remarkModal.close();
      } catch (e) {}
    },
    handleCancelRemake() {
      this.remakeMadel = false;
    },
    closeModel() {
      this.hunterModel = false;
    },
    clickCustomRow(record) {
      // 事件
      return {
        props: {},
        on: {
          // 事件
          click: async () => {
            await this.getGunterInfo(record.id);
            this.hunterModel = true;
          },
        },
      };
    },
    async getGunterInfo(id) {
      let params = { user_id: id };
      let response = await Api.hunter.getHunterInfo(params);
      this.hunterInfo = response.user;
      console.log(response, "hunterInfo");
    },
    signData() {
      this.signModel = true;
    },
    async saveSign(confirm) {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.log(values);
          await Api.hunter.addSign(values);
          this.signModel = false;
          this.$message.info("标记成功！");
        }
      });
    },
    getPromotionLinks() {
      this.promotionLinks = true;
    },
    copyUrl() {
      this.promotionLinks = false;
      this.$message.info("复制成功！");
    },
    cancelCopy() {
      this.promotionLinks = false;
    },
    onError() {
      this.$message.info("复制失败请手动复制！");
    },
    async changeValidHunter(id) {
      await Api.hunter.changeValidHunter({ user_id: id });
      this.getData(null, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.post {
  .sort-bar {
    text-align: center;
    margin-top: 11px;
    border-radius: 3px;

    border: 1px solid rgba(228, 232, 235, 1);
    .sort {
      cursor: pointer;
      height: 58px;
      line-height: 58px;
      color: #909399;
      &.active {
        color: #5ec9ff;
      }
    }
  }
  .table-con {
    margin-top: 11px;
    border-radius: 3px;
    border-bottom: 1px solid rgba(228, 232, 235, 1);
    padding: 20px;
    text-align: left;
    cursor: pointer;
  }
  .hunter-table {
    margin-top: 10px;
  }
  .action {
    a {
      text-decoration: underline;
    }
  }
}
.title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  padding-bottom: 20px;
}
.model-list {
  font-size: 14px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
  div:first-child {
    width: 200px;
  }
}
.info {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
  div {
    flex: 1;
  }
}
.tips {
  color: #fc5646;
  font-size: 14px;
  margin-top: 20px;
}
.listtitle {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
.row-content {
  margin-left: 10px;
  .col {
    width: 50%;
    margin-bottom: 10px;
    .active {
      color: #35b5fe;
    }
  }
  .row {
    width: 100%;
    margin-bottom: 10px;
    .active {
      color: #35b5fe;
    }
  }
}
.blue {
  color: #35b5fe;
}
.invalid-btn {
  position: absolute;
  right: 15px;
}
</style>
